import { useEffect, useMemo } from "react";
import { Alert } from "@/base/components/index";
import { LocalizationText } from "@/app/index";
import { useMessageBoundaryStyles } from "./message-boundary.styles";
import { MessageBoundaryProps } from "../types/index";
import { cx } from "antd-style";
import { useNotifications } from "@/app/hook/use-notifications";

export const MessageBoundary = ({
  className,
  level = "global",
}: MessageBoundaryProps) => {
  const { styles } = useMessageBoundaryStyles();
  const notifications = useNotifications(level);

  const configs = useMemo(() => {
    const { currentMessage } = notifications;

    if (!currentMessage?.componentProps) {
      return null;
    }
    const props = currentMessage?.componentProps;
    const message = props?.message;

    return {
      showIcon: true,
      ...props,
      message: message || (
        <LocalizationText value="widgets.message.boundary.default.error" />
      ),
    };
  }, [notifications]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      notifications.removeCurrentMessage();
    }, 7000);
    return () => timeout && clearTimeout(timeout);
  }, [configs]);

  if (!configs) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      {!!configs && <Alert {...configs} />}
    </div>
  );
};
